import React from 'react';
import { processSteps } from '../mockData';
import { CheckCircle } from 'lucide-react';

const Process = () => {
  return (
    <section className="py-32 bg-white relative overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        {/* Modern Section Header - Left Aligned */}
        <div className="mb-20">
          <div className="flex items-center space-x-3 mb-4">
            <div className="w-1 h-8 bg-gradient-to-b from-orange-500 to-amber-500"></div>
            <span className="text-orange-600 font-bold text-sm uppercase tracking-widest">Simple Process</span>
          </div>
          <h2 className="text-5xl md:text-6xl font-black text-gray-900 mb-6">
            How It
            <span className="block bg-gradient-to-r from-orange-600 to-amber-600 bg-clip-text text-transparent">Works</span>
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl leading-relaxed">
            Get started in minutes with our streamlined onboarding process
          </p>
        </div>

        {/* Modern Timeline Layout */}
        <div className="relative">
          {/* Vertical Line */}
          <div className="hidden lg:block absolute left-12 top-0 bottom-0 w-0.5 bg-gradient-to-b from-orange-500 to-amber-500"></div>

          <div className="space-y-16">
            {processSteps.map((step, index) => (
              <div key={step.step} className="relative flex items-start">
                {/* Step Number - Modern Design */}
                <div className="flex-shrink-0 relative">
                  <div className="w-24 h-24 bg-gradient-to-br from-orange-500 to-amber-500 rounded-2xl flex items-center justify-center shadow-lg">
                    <span className="text-white font-black text-4xl">{step.step}</span>
                  </div>
                  {/* Connection Dot */}
                  <div className="hidden lg:block absolute -right-8 top-1/2 -translate-y-1/2 w-4 h-4 bg-orange-500 rounded-full"></div>
                </div>

                {/* Content Card */}
                <div className="ml-8 lg:ml-16 flex-grow">
                  <div className="bg-white rounded-2xl p-8 border-2 border-gray-100 hover:border-orange-200 hover:shadow-xl transition-all duration-300">
                    <h3 className="text-3xl font-black text-gray-900 mb-4">
                      {step.title}
                    </h3>
                    <p className="text-lg text-gray-600 leading-relaxed mb-6">
                      {step.description}
                    </p>
                    
                    {/* Benefits */}
                    <div className="flex flex-wrap gap-2">
                      {[
                        'Fast Setup',
                        'No Hidden Fees',
                        'Expert Support'
                      ].map((benefit, idx) => (
                        <div key={idx} className="inline-flex items-center space-x-2 bg-orange-50 rounded-lg px-4 py-2">
                          <CheckCircle size={16} className="text-orange-600" />
                          <span className="text-orange-600 font-bold text-sm">{benefit}</span>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Bottom CTA */}
        <div className="mt-20 text-center">
          <p className="text-2xl text-gray-900 mb-6 font-bold">Ready to get started?</p>
          <a
            href="/contact"
            className="inline-flex items-center space-x-2 bg-gradient-to-r from-orange-500 to-amber-500 text-white px-10 py-5 rounded-xl font-bold text-lg hover:shadow-2xl hover:shadow-orange-500/50 transition-all duration-300"
          >
            <span>Start Your Journey Now</span>
          </a>
        </div>
      </div>
    </section>
  );
};

export default Process;